import i18n from "../../../../constants/i18n";
import { CSR_MY_CSR_PREV_ACTIONS_HEADERS } from "../../../../constants/table-custom-headers/CSR";
import getMyCSRPrevActionsStore from "../../../../stores/csr-store/csr-prev-actions";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Table from "../../../../core/et3-table";

const MyCSRPrevActionsTable = withLiteObserverAndTheme(() => {
  const auditedEvents =
    getMyCSRPrevActionsStore().csrPrevActionsListOrdered.get();

  return (
    <Et3Table
      columns={CSR_MY_CSR_PREV_ACTIONS_HEADERS}
      rows={auditedEvents}
      title={i18n.get("MY_CSR_PREV_ACTIONS")}
      shouldBeFlagged={false}
      titleKey={"MY_CSR_PREV_ACTIONS"}
    />
  );
});

export default MyCSRPrevActionsTable;
